export function containsAny<T>(array: T[], toCheck: T[]) {
  return toCheck.some(str => array.includes(str));
}
